import React from 'react';
import { onSetActivePage, onSetActiveGeography } from '../../data/StatusStore';
interface AboutScreenProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutScreen: React.FC<AboutScreenProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    // Clicking the semi-transparent overlay closes the splash
    const handleOverlayClick = () => {
        onClose();
    };

    // Prevent closing when clicking inside the dialog
    const handleDialogClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    };

    const hdiDataStory = () => {
        console.log('HDI Data Story clicked');
        onSetActiveGeography('CD');
        onSetActivePage('stories');
        onClose();
    };
    const getStarted = () => {
        console.log('Get Staerted');
        onClose();
    };

    return (
        <div
        className="splash-overlay"
        onClick={handleOverlayClick}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgb(165 96 0 / 80%)',
            zIndex: 999999, // High enough to cover navbar
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        >
        <div
            className="splash-dialog"
            onClick={handleDialogClick}
            style={{
            position: 'relative',
            width: '719px',
            maxWidth: '90%',
            height: 'calc(100vh - 100px)',
            backgroundColor: '#fff',
            padding: '24px 30px',
            paddingRight: '0px',
            borderRadius: '25px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'left',
            lineHeight: 1.5,
            border: '2px solid black',
            }}
        >
            {/* Close Button (X) */}
            <button
            onClick={onClose}
            style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'transparent',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                lineHeight: '1',
            }}
            >
            &times;
            </button>
            {/* CONTENT FROM https://docs.google.com/document/d/1X7pEYnYSX4BNIornGxtNEOdvC91uD1Rq/edit */}
            <body 
                style={{ overflowY:'scroll', paddingRight: '20px', margin: 0, fontSize: '18px', lineHeight:'22px' }}
                className="c11 doc-content"
            ><br></br>
                <p className="c3"><span className="c8">DATA2GO</span><span className="c5">.NYC</span><span className="c8">&nbsp;is a free,
                        easy-to-use online mapping and data tool created by the nonprofit&nbsp;</span><span className="c5">Measure of
                        America</span><span className="c8">&nbsp;with funding from&nbsp;</span><span className="c5">The Leona M. and Harry
                        B. Helmsley Charitable Trust</span><span className="c0">.</span></p>
                <p className="c3"><span className="c8">DATA2GO</span><span className="c5">.NYC</span><span className="c8">&nbsp;brings together
                        federal, state, and city data on a broad range of issues critical to the well-being of all New Yorkers.
                    </span><span className="c8 c14">The website includes over 400 indicators from a wide range of sectors for New York
                        City&rsquo;s five boroughs, 59 community districts, and its nearly 200 neighborhoods. Created</span><span
                        className="c0">&nbsp;to provide reliable, up-to-date information on neighborhood assets and challenges, it is a
                        tool people who are dedicated to a city in which &quot;everyone counts&quot; can use to craft effective
                        solutions, target policies and services, advocate for change, and hold elected officials accountable for
                        human progress. </span></p>
                <p className="c3"><span className="c0">The data come predominantly from public entities, including the US Census Bureau and
                        the US Bureau of Labor Statistics, the New York State Departments of Health and of Agriculture and Markets,
                        and New York City agencies responsible for promoting the well-being of New Yorkers in many areas:
                        children&rsquo;s services, corrections, education, environmental protection, health, homelessness,
                        sanitation, the police and fire departments, and more.</span></p>
                <p className="c1"><span className="c0">For more detailed information, see the&nbsp;FAQ.</span></p>
                <p className="c1"><span className="c12 c6"><a className="c7"
                            href="https://measureofamerica.org" target="_blank">Measure
                            of America</a></span><span>&nbsp;is a nonpartisan research and advocacy initiative of
                        the&nbsp;</span><span className="c12 c6"><a className="c7"
                            href="https://ssrc.org" target="_blank">Social
                            Science Research Council</a></span><span>. We provide easy-to-use yet methodologically sound tools that
                        measure what matters for human well-being, freedom, and opportunity. Through reports and online tools like
                        DATA2GO.</span><span className="c5">NYC</span><span className="c0">, Measure of America works with partners to
                        breathe life into numbers, using data to create compelling narratives that foster understanding of
                        inequalities and build support for people-centered policies. This work is grounded in a strong conceptual
                        framework, Nobel Laureate Amartya Sen&rsquo;s capabilities approach.</span></p>
                <p className="c1"><span className="c12 c6"><a className="c7"
                            href="https://helmsleytrust.org" target="_blank">The
                            Helmsley Charitable Trust</a></span><span className="c0">&nbsp;is a global philanthropy committed to helping
                        people live better lives today and creating stronger, healthier futures for individuals and communities,
                        partnering with people and organizations to invest in new ideas or research.</span></p>
                <p className="c1"><span className="c5">Suggested attribution:</span><br></br><span>Measure of America, [Year]. </span><span
                        className="c15">DATA2GO.NYC. </span><span>www.data2go.nyc. </span></p>
                <p className="c1 c9"><span className="c2"></span></p>
                <p className="c1"><span className="c6">DATA2GO Team</span></p>
                <p className="c1"><span className="c6">Core Team</span><span className="c0">: Kristen Lewis, Alex Powers, Kate Harvey, Tara
                        Shawa, Cara Wohnsigl&nbsp; </span></p>
                <p className="c1"><span className="c6">Design</span><span>: </span><span className="c12"><a className="c7"
                            href="https://rostenwoo.biz" target="_blank">Rosten
                            Woo</a></span></p>
                <p className="c1"><span className="c6">Application Development and Cartography</span><span>: </span><span className="c12"><a
                            className="c7"
                            href="https://codiesee.com" target="_blank">Codie See</a></span></p>
                <p className="c1"><span className="c6">Core MOA Alumnae</span><span className="c0">: Rebecca Gluskin, Laura Laderman</span></p>
                <p className="c1"><span className="c6">Color and Brand Identity</span><span>: </span><span className="c12"><a className="c7"
                            href="https://humantific.com" target="_blank">Humantific</a></span>
                </p>
                <p className="c1"><span className="c6">Illustrations</span><span>: </span><span className="c12"><a className="c7"
                            href="https://tiffanie.world" target="_blank">Tiffanie
                            Tran</a></span></p>
                <p className="c1"><span className="c6">Consultants and Interns</span><span className="c0">: Ilanith Nizard, Sophie Sharps, Halle
                        Mitchell, Julia Russ, Winnie Zhou, Ermina Chowdhury</span></p>
                <p className="c1 c9"><span className="c2"></span></p><br></br>
                <p className="c1"><span className="c2">DATA2GO Advisory Panel</span></p>
                <ul className="c13 lst-kix_list_3-0 start">
                    <li className="c1 c4 li-bullet-0"><span className="c6">Joshua Aiyedun, PhD </span><span className="c0">United Way of
                            NYC</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jay Bala </span><span className="c0">NYC Health Department</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Adam Barin </span><span>Mayor&#39;s Office of Operations</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Liz Castellano </span><span className="c0">Make The Road New
                            York</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Nevin Cohen, PhD </span><span>CUNY Urban Food Policy
                            Institute</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Kacie Dragan, PhD </span><span className="c0">The Dartmouth Institute
                            for Health Policy and Clinical Practice</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Ester Fuchs, PhD </span><span className="c0">Columbia
                            University</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Moses Gates </span><span className="c0">Regional Plan
                            Association</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jon Goldman </span><span>Robin Hood</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Zachariah Hennessey </span><span className="c0">Public Health
                            Solutions</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Carson Hicks, PhD </span><span className="c0">Mayor&rsquo;s Office
                            for Economic Opportunity</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Oonagh Jordan </span><span>Mayor&rsquo;s Office for Economic
                            Opportunity</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Philip Kasinitz, PhD </span><span>CUNY Graduate Center</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Sunaina Rao </span><span>Generation Citizen</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Sonya Reynolds </span><span>The Movement Cooperative</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Oscar Romero </span><span>NYC Civic Engagement Commission</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Sarah Sayeed, PhD </span><span>NYC Civic Engagement
                            Commission</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">David Schleifer, PhD </span><span className="c0">Peterson Center on
                            Healthcare</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Daniel Steinberg, PhD </span><span className="c0">Mayor&#39;s Office
                            of Operations</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Maushumi Suttles </span><span className="c0">RiseBoro</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Glenn Wolff-Eisenberg </span><span className="c0">New York Cares
                        </span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jason Wu </span><span>Human Services Council</span></li>
                </ul>
                <p className="c1 c9"><span className="c2"></span></p><br></br>
                <p className="c1"><span className="c6">First DATA2GO Advisory Panel</span></p>
                <ul className="c13 lst-kix_list_2-0 start">
                    <li className="c1 c4 li-bullet-0"><span className="c6">Nancy Andiloro</span><span className="c0">&nbsp;NYC Department of
                            Probation</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Steve Bezman</span><span className="c0">&nbsp;NYC Department of
                            Information Technology and Telecommunications</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Ronna Brown</span><span className="c0">&nbsp;Philanthropy NY</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Dorothy Browne</span><span className="c0">&nbsp;Boy Scouts of
                            America</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jintana Chiu&nbsp;</span><span className="c0">Mayor&rsquo;s Office of
                            Operations</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Dalton Conley</span><span className="c0">&nbsp;New York
                            University</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Lisa Cowan</span><span className="c0">&nbsp;Red Hook
                            Initiative</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Christine D&rsquo;Onofrio</span><span className="c0">&nbsp;NYC Center
                            for Economic Opportunity</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Sheldon Danziger</span><span className="c0">&nbsp;Russell Sage
                            Foundation</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Cynthia Esposito Lamy</span><span className="c0">&nbsp;Robin
                            Hood</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Ester Fuchs</span><span className="c0">&nbsp;Columbia University -
                            SIPA</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Katherine Greig</span><span className="c0">&nbsp;Mayor&rsquo;s Office
                            of Long-Term Planning and Sustainability</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Bernell Grier</span><span className="c0">&nbsp;Neighborhood Housing
                            Services of New York City, Inc.</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Angela Hariche</span><span className="c0">&nbsp;Foundation
                            Center</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Ben Kallos</span><span className="c0">&nbsp;NYC Council Member,
                            District 5</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Josef Kannegaard</span><span className="c0">&nbsp;Institute for
                            Children, Poverty, and Homelessness</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Matt Klein</span><span className="c0">&nbsp;NYC Center for Economic
                            Opportunity &amp; Mayor&rsquo;s Office of Operations</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Laura Kurgan&nbsp;</span><span className="c0">Columbia University -
                            GSAPP</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jennifer March</span><span className="c0">&nbsp;Citizens&#39;
                            Committee for Children of New York</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">John Mollenkopf</span><span className="c0">&nbsp;CUNY Graduate
                            Center</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Lindsay Mollineaux</span><span className="c0">&nbsp;Mayor&rsquo;s
                            Office of Data Analytics</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Morgan Monaco</span><span className="c0">&nbsp;Mayor&rsquo;s Office
                            of Operations</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Nebahat Noyan</span><span className="c0">&nbsp;NYC Center for
                            Innovation through Data Intelligence</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Nicholas O&rsquo;Brien</span><span className="c0">&nbsp;Mayor&rsquo;s
                            Office of Data Analytics</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Nicole Pritchard</span><span className="c0">&nbsp;Neighborhood
                            Housing Services of New York City, Inc.</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Joseph Pupello</span><span className="c0">&nbsp;Zone A New
                            York</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Steven Romalewski</span><span className="c0">&nbsp;CUNY Graduate
                            Center</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Susan Saegert&nbsp;</span><span className="c0">CUNY Graduate
                            Center</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jilly Stephens</span><span className="c0">&nbsp;City Harvest</span>
                    </li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Ben Wellington</span><span className="c0">&nbsp;iQuantNY, Pratt
                            Institute, Two Sigma Investments</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Jason Wu</span><span className="c0">&nbsp;Human Services
                            Council</span></li>
                    <li className="c1 c4 li-bullet-0"><span className="c6">Aurora Zepeda</span><span className="c0">&nbsp;Homes for the
                            Homeless</span></li>
                </ul>
                <p className="c10 c9"><span className="c0"></span></p>
                <p className="c9 c10"><span className="c0"></span></p>
            </body>
        </div>
        </div>
    );
};

export default AboutScreen;
